export function getScrollPositionStorageKey({
  page,
  projectId,
}: {
  page: string;
  projectId: string;
}): string {
  return `mapistry:scrollTop:${page}:${projectId}`;
}

export function readSavedScrollPosition(key: string): number | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) {
      return null;
    }
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeSavedScrollPosition(key: string, scrollTop: number) {
  try {
    sessionStorage.setItem(key, String(scrollTop));
  } catch {
    // sessionStorage unavailable
  }
}

export function clearSavedScrollPosition(key: string) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // sessionStorage unavailable
  }
}
